import { Box, BoxProps, Button, ButtonProps, Flex, Stack, Text } from '@chakra-ui/react';
// import { useConfig } from 'src/modules';
import { useConfig } from '@MGPD/myasurion-shared/modules/config';
import {
    TextScript,
  } from '@MGPD/myasurion-shared';
import { LockIcon } from '@chakra-ui/icons';
import CloudIcon from './CloudIcon';

export interface RateButtonProps {
    label: string;
    onClick: () => void;
}

export interface CloseButtonProps {
    label: string;
    onClick: () => void;
}

export interface HowToFindButtonProps {
    label: string;
    onClick: () => void;
}

export interface ConfirmationAfterSubmissionProps {
    title?: string;
    heading?: string;
    serviceRequestdetails?: string;
    text1?: string;
    subheading1?: string;
    subheadingcontent1?: string;
    subheadingcontent2?: string;
    subheading2?: string;
    subheading2content1?: string;
    subheading2content2?: string;
    subheading3?: string;
    subheading3content1?: string;
    info1?: string;
    info1content?: string;
    info2?: string;
    info2content?: string;
    info3?: string;
    info3content?: string;
    lblhowtofind?: string;
    Date?: string;
    lblrate?: string;
    lblclose?: string;
    searchTitle?: string;
    expertGroupImage?: string;
    doAnimate?: boolean;
    rateButtonProps?: RateButtonProps;
    closeButtonProps?: CloseButtonProps;
    howToFindButtonProps?: HowToFindButtonProps;
    IncidentType?: string;
    paymentBreakdown?: string;
    serviceRequestFee?: string;
    serviceRequestFeeAmount?: string;
    dataTransferFeesVal?: string;
    dataTransferFeesLBL?: string;
    nightDelivery?: string;
    nightDeliveryAmount?: string;
    subTotal?: string;
    subTotalAmount?: string;
    Discount?: string;
    DiscountAmount?: string;
    TotalAfterDiscount?: string;
    TotalAmountAfterDiscount?: string;
    RequestedServicelbl?: string;
    Summarylbl?: string;
    RequestedServicevalue?: string;
    IMEIlbl?: string;
    IMEIvalue?: string;
    RequestTypelbl?: string;
    RequestTypevalue?: string;
    DeliveryAddresslbl?: string;
    Deliveryaddressvalue?: string;
    DeliveryDateTimelbl?: string;
    DeliveryDateTimevalue?: string;
    returnAddrsLBL?: string;
    returnAddrsVal?: string;
    returnDateTimeLBL?: string;
    returnDateTimeVal?: string;
    LFLStock?: boolean;
    isWarranty?: boolean;
    isWalkin?: boolean;
    requestId?: string;
    DateTime?: string;
    make?: boolean;
    showSurvey?: boolean;
    alternativeContactNumber?: string;
    warrantyReturn?: boolean;
}

export const ConfirmationAfterSubmission = ({
    title = 'Your request is submitted.',
    heading = 'Your request ID:',
    requestId = '',
    text1 = '',
    subheading1 = 'What happens next?',
    subheadingcontent1 = '',
    DateTime = '',
    subheadingcontent2 = '',
    subheading2 = '',
    subheading2content1 = '',
    subheading2content2 = '',
    subheading3 = '',
    subheading3content1 = '',
    info1 = '',
    info1content = '',
    info2 = '',
    info2content = '',
    info3 = '',
    info3content = '',
    searchTitle = '',
    lblhowtofind = '',
    lblrate = '',
    lblclose = 'Close this page',
    rateButtonProps,
    closeButtonProps,
    howToFindButtonProps,
    IncidentType,
    doAnimate = false,
    Date,
    expertGroupImage,
    serviceRequestdetails = '',
    paymentBreakdown = '',
    serviceRequestFee = '',
    serviceRequestFeeAmount = '',
    dataTransferFeesVal = '',
    dataTransferFeesLBL = '',
    nightDelivery = '',
    nightDeliveryAmount = '',
    subTotal = '',
    subTotalAmount = '',
    Discount = '',
    DiscountAmount = '',
    TotalAfterDiscount = '',
    TotalAmountAfterDiscount = '',
    RequestedServicelbl = '',
    Summarylbl = '',
    RequestedServicevalue = '',
    IMEIlbl = '',
    IMEIvalue = '',
    RequestTypelbl = '',
    RequestTypevalue = '',
    DeliveryAddresslbl = '',
    Deliveryaddressvalue = '',
    DeliveryDateTimelbl = '',
    DeliveryDateTimevalue = '',
    returnAddrsLBL,
    returnAddrsVal,
    returnDateTimeLBL,
    returnDateTimeVal,
    LFLStock,
    isWarranty = false,
    isWalkin = false,
    make,
    showSurvey = true,
    alternativeContactNumber = '',
    warrantyReturn = false,
    ...props
}: ConfirmationAfterSubmissionProps & BoxProps & ButtonProps) => {
    const pageName = 'ConfirmationAfterSubmission';

    const { data } = useConfig();
    const { theme } = data;
    const { colors } = theme;
    const { accent } = colors;
   console.log('props',props)
   console.log('incidentType',IncidentType)
    return (
        <Box>
            <Box
                p={'16px , 16px'}
                {...props}
                w={{ base: 'full', lg: '60%' }}
                margin={{ base: '0', lg: 'auto' }}
                pb={{ base: '0', lg: '100px' }}
            >
                <Text fontSize="3xl" mb={'8px'}>
                    <TextScript text={title} translationKey={`${pageName}/title`} />
                </Text>
                <Flex>
                    <Text fontSize="lg" mr={1}>
                        <TextScript text={heading} translationKey={`${pageName}/heading`} />
                    </Text>
                    <Text as={'b'} fontSize="lg">
                        {requestId}
                    </Text>
                </Flex>
                {LFLStock && (
                    <Box>
                        <Box mb={'34px'} pt={'8px'}>
                            <Flex
                                direction={{ base: 'column', lg: 'row' }}
                                justifyContent={{ base: 'start', lg: 'space-between' }}
                            >
                                <Box
                                    w={{ base: 'full', lg: '50%' }}
                                    border={{ base: 'none', lg: '1px' }}
                                    padding={{ base: '0', lg: '10px 16px' }}
                                    borderRadius={{ base: 'none', lg: '16px' }}
                                    borderColor={{ base: 'none', lg: '#adaaaa' }}
                                >
                                    <Text fontSize="2xl" fontWeight={'light'}>
                                        <TextScript
                                            text={serviceRequestdetails}
                                            translationKey={`${pageName}/serviceRequestdetails`}
                                        />
                                    </Text>
                                    {/* <Box fontWeight={700} fontSize={''} mt={2}>
                                        {Summarylbl}
                                    </Box> */}
                                    {RequestedServicelbl && (
                                        <Box fontWeight={700} mt={2}>
                                            <TextScript
                                                text={RequestedServicelbl}
                                                translationKey={`Global/RequestedService`}
                                            />
                                        </Box>
                                    )}
                                    <Box>
                                        <Text>{RequestedServicevalue}</Text>
                                    </Box>
                                    {IMEIlbl && (
                                        <Box fontWeight={700} mt={2}>
                                            <TextScript
                                                text={IMEIlbl}
                                                translationKey={`${pageName}/lblIMEI`}
                                            />
                                        </Box>
                                    )}
                                    <Box>
                                        <Text>{IMEIvalue}</Text>
                                    </Box>
                                    {RequestTypelbl && (
                                        <Box fontWeight={700} mt={2}>
                                            <TextScript
                                                text={RequestTypelbl}
                                                translationKey={`Global/RequestType`}
                                            />
                                        </Box>
                                    )}
                                    <Box>
                                        <Text>{RequestTypevalue}</Text>
                                    </Box>
                                    {alternativeContactNumber && (
                                        <Box mt={2} fontWeight={700}>
                                            <TextScript
                                                text={'Alternate Contact Number'}
                                                translationKey={`Global/AlternativeContactNumber`}
                                            />
                                        </Box>
                                    )}
                                    <Box>
                                        <Text>{alternativeContactNumber}</Text>
                                    </Box>
                                    {DeliveryAddresslbl && (
                                        <Box>
                                            <Text fontWeight={700} mt={2}>
                                                {DeliveryAddresslbl}
                                            </Text>
                                        </Box>
                                    )}
                                    <Box>{Deliveryaddressvalue}</Box>
                                    {DeliveryDateTimelbl && (
                                        <Box fontWeight={700} mt={2}>
                                            <Text>{DeliveryDateTimelbl}</Text>
                                        </Box>
                                    )}
                                    <Box>
                                        <Text>{DeliveryDateTimevalue}</Text>
                                    </Box>
                                    <Box mt={2} fontWeight={700}>
                                        {returnAddrsLBL}
                                    </Box>
                                    <Box>
                                        <Text>{returnAddrsVal}</Text>
                                    </Box>
                                    <Box mt={2} fontWeight={700}>
                                        {returnDateTimeLBL}
                                    </Box>
                                    <Box>
                                        <Text>{returnDateTimeVal}</Text>
                                    </Box>
                                </Box>{' '}
                                {(warrantyReturn || !isWarranty) && ( // warrantyreturn will be false for all other cases
                                    <>
                                        <Box display={{ base: 'none', lg: 'block' }}>
                                            <hr style={{ marginTop: '8px' }} />
                                        </Box>
                                        <Box mt={'16px'} mb={'16px'}>
                                            <hr
                                                style={{
                                                    border: 'none',
                                                    borderTop: '2px solid #adaaaa',
                                                }}
                                            />
                                        </Box>
                                        <Box w={{ base: 'full', lg: '45%' }}>
                                            {paymentBreakdown && (
                                                <Text my={3} fontWeight={700}>
                                                    <TextScript
                                                        text={paymentBreakdown}
                                                        translationKey={`${pageName}/lblPaymentBreakdown`}
                                                    />
                                                </Text>
                                            )}
                                            <Flex
                                                mb={3}
                                                direction="row"
                                                justifyContent="space-between"
                                            >
                                                {serviceRequestFee && (
                                                    <>
                                                        <Text>
                                                            {serviceRequestFee}
                                                            {/* <TextScript
                                                            text={serviceRequestFee}
                                                            translationKey={`${pageName}/lblServiceRequestFee`}
                                                        /> */}
                                                        </Text>
                                                        <Text>{serviceRequestFeeAmount}</Text>
                                                    </>
                                                )}
                                            </Flex>
                                            <Flex
                                                mb={3}
                                                direction="row"
                                                justifyContent="space-between"
                                            >
                                                {dataTransferFeesLBL && (
                                                    <Text>
                                                        <TextScript
                                                            text={dataTransferFeesLBL}
                                                            translationKey={`${pageName}/lblDataTransferFees`}
                                                        />
                                                    </Text>
                                                )}
                                                <Text>{dataTransferFeesVal}</Text>
                                            </Flex>
                                            <Flex
                                                mb={3}
                                                direction="row"
                                                justifyContent="space-between"
                                            >
                                                {nightDelivery && (
                                                    <Text>
                                                        <TextScript
                                                            text={nightDelivery}
                                                            translationKey={`${pageName}/lblNightDelivery`}
                                                        />
                                                    </Text>
                                                )}
                                                <Text>{nightDeliveryAmount}</Text>
                                            </Flex>
                                            {!isWarranty && (
                                                <hr
                                                    style={{
                                                        border: 'none',
                                                        borderTop: '2px dotted #adaaaa',
                                                    }}
                                                />
                                            )}
                                            <Flex
                                                my={2}
                                                direction="row"
                                                justifyContent="space-between"
                                            >
                                                {subTotal && (
                                                    <Text>
                                                        <TextScript
                                                            text={subTotal}
                                                            translationKey={`Global/Subtotal`}
                                                        />
                                                    </Text>
                                                )}
                                                <Text>{subTotalAmount}</Text>
                                            </Flex>
                                            <Flex
                                                mb={2}
                                                direction="row"
                                                justifyContent="space-between"
                                            >
                                                <Text>{Discount}</Text>
                                                <Text>{DiscountAmount}</Text>
                                            </Flex>
                                            <Flex
                                                mb={2}
                                                direction="row"
                                                justifyContent="space-between"
                                            >
                                                {TotalAfterDiscount && (
                                                    <Text fontWeight={700}>
                                                        <TextScript
                                                            text={TotalAfterDiscount}
                                                            translationKey={`Global/Total`}
                                                        />
                                                    </Text>
                                                )}
                                                <Text fontWeight={700}>
                                                    {TotalAmountAfterDiscount}
                                                </Text>
                                            </Flex>
                                        </Box>
                                        <Box mt={'16px'} mb={'16px'}>
                                            <hr
                                                style={{
                                                    border: 'none',
                                                    borderTop: '2px solid #adaaaa',
                                                }}
                                            />
                                        </Box>
                                    </>
                                )}
                            </Flex>
                            {/* <hr style={{ marginTop: '8px' }} />
                        
                        <hr /> */}
                        </Box>
                    </Box>
                )}
                {text1 && (
                    <Text fontWeight="light" fontSize="lg" mb={'36px'}>
                        {text1}
                    </Text>
                )}

                {
                    <>
                        {subheading1 && (
                            <Text
                                fontWeight="light"
                                fontSize="2xl"
                                mb={'8px'}
                            >
                                <TextScript
                                    text={subheading1}
                                    translationKey={`${pageName}/lblSubheading1`}
                                />
                            </Text>
                        )}
                        {subheadingcontent1 && (
                            <Flex>
                                <Text
                                    fontWeight="light"
                                    fontSize="lg"
                                    mb={'36px'}
                                >
                                    {subheadingcontent1} <b>{DateTime}</b>
                                </Text>
                            </Flex>
                        )}
                    </>
                }
                {subheadingcontent2 && (
                    <Text fontWeight="light" fontSize="lg" mb={'24px'}>
                        {subheadingcontent2}
                    </Text>
                )}
                {subheading2 && (
                    <Text fontWeight="light" fontSize="2xl" mb={'8px'}>
                        <TextScript
                            text={subheading2}
                            translationKey={`${pageName}/lblSubheading2`}
                        />
                    </Text>
                )}
                {subheading2content2 && (
                    <Text fontWeight="light" fontSize="lg" mb={'8px'}>
                        <TextScript
                            text={subheading2content2}
                            translationKey={`${pageName}/lblSubheading2Content2`}
                        />
                    </Text>
                )}
                {subheading2content1 && (
                    <Text fontWeight="light" fontSize="lg" mb={'8px'}>
                        <TextScript
                            text={subheading2content1}
                            translationKey={`${pageName}/lblSubheading2Content1`}
                        />
                    </Text>
                )}
                {!warrantyReturn && make && IncidentType?.toUpperCase() !== 'REPLACEMENT' && (
                    <Stack mb={'24px'} p={'0px , 16px'}>
                        <Button
                            // paddingX={'16px'}
                            paddingY={'12px'}
                            colorScheme={'black'}
                            justifyContent={'flex-start'}
                            minWidth={'343px'}
                            fontWeight={'400'}
                            onClick={() => howToFindButtonProps?.onClick?.()}
                            variant="link"
                            as={'u'}
                        >
                            {lblhowtofind && (
                                <TextScript
                                    text={lblhowtofind}
                                    translationKey={`${pageName}/lblHowToFind`}
                                />
                            )}
                        </Button>
                    </Stack>
                )}
                {!warrantyReturn && subheading3 && (
                    <Text fontWeight="light" fontSize="2xl" mb={'8px'}>
                        <TextScript
                            text={subheading3}
                            translationKey={`${pageName}/lblSubHeading3`}
                        />
                    </Text>
                )}
                {!warrantyReturn && subheading3content1 && (
                    <Text
                        fontWeight="light"
                        fontSize="lg"
                        mb={'24px'}
                        whiteSpace="pre-line"
                    >
                        <TextScript
                            text={subheading3content1}
                            translationKey={`${pageName}/lblSubheading3Content1`}
                        />
                    </Text>
                )}
                {/* {IncidentType === 'SWAP' && ( */}
                <Box>
                    {!warrantyReturn && make && IncidentType?.toUpperCase() !== 'REPLACEMENT' && (
                        <Flex mb={'24px'}>
                            <CloudIcon
                            ></CloudIcon>
                            <Flex direction={'column'}>
                                {info1 && (
                                    <Text
                                        fontWeight="bold"
                                        fontSize="sm"
                                        m={0}
                                    >
                                        <TextScript
                                            text={info1}
                                            translationKey={`${pageName}/lblInfo11`}
                                        />
                                    </Text>
                                )}
                                {info1content && (
                                    <Text
                                        fontWeight="light"
                                        fontSize="sm"
                                    >
                                        <TextScript
                                            text={info1content}
                                            translationKey={`${pageName}/lblInfo1Content`}
                                        />
                                    </Text>
                                )}
                            </Flex>
                        </Flex>
                    )}
                    {!warrantyReturn && make && IncidentType?.toUpperCase() !== 'REPLACEMENT' && (
                        <Flex mb={'24px'}>
                            <LockIcon
                                marginTop={'6px'}
                                borderRadius={'64px'}
                                marginRight={'20px'}
                                flexShrink={0}
                            ></LockIcon>
                            <Flex direction={'column'}>
                                {info2 && (
                                    <Text
                                        fontWeight="bold"
                                        fontSize="sm"
                                        m={0}
                                    >
                                        <TextScript
                                            text={info2}
                                            translationKey={`${pageName}/lblInfo2`}
                                        />
                                    </Text>
                                )}
                                {info2content && (
                                    <Text
                                        fontWeight="light"
                                        fontSize="sm"
                                    >
                                        <TextScript
                                            text={info2content}
                                            translationKey={`${pageName}/lblInfo2Content`}
                                        />
                                    </Text>
                                )}
                            </Flex>
                        </Flex>
                    )}
                    {IncidentType?.toUpperCase() === 'SWAP' && (
                        <Flex mb={'24px'}>
                            <Flex direction={'column'}>
                                {info3 && (
                                    <Text
                                        fontWeight="bold"
                                        fontSize="sm"
                                        m={0}
                                    >
                                        <TextScript
                                            text={info3}
                                            translationKey={`${pageName}/lblInfo3`}
                                        />
                                    </Text>
                                )}
                                {info3content && (
                                    <Text
                                        fontWeight="light"
                                        fontSize="sm"
                                    >
                                        <TextScript
                                            text={info3content}
                                            translationKey={`${pageName}/lblInfo3content`}
                                        />
                                    </Text>
                                )}
                            </Flex>
                        </Flex>
                    )}
                </Box>
                {/* )} */}
            </Box>
            <Box
                position={{ base: 'relative', lg: 'fixed' }}
                bottom="0"
                w="full"
                mt={'36px'}
                pb="10px"
                bgColor={{ base: '', lg: '#faf9f5' }}
                display={showSurvey ? 'block' : 'none'}
            >
                <Box display={{ base: 'none', lg: 'block' }}>
                    <hr
                        style={{
                            border: 'none',
                            borderTop: '2px solid #adaaaa',
                        }}
                    />
                </Box>
                <Flex direction={{ base: 'column', lg: 'row-reverse' }} align={'center'} py="10px">
                    <Button
                        paddingX={'16px'}
                        paddingY={'12px'}
                        colorScheme={'primary'}
                        // minWidth={'343px'}
                        w={{ base: 'full', lg: '13%' }}
                        margin={'auto'}
                        onClick={() => rateButtonProps?.onClick?.()}
                    >
                        {lblrate && (
                            <TextScript text={lblrate} translationKey={`${pageName}/lblRate`} />
                        )}
                    </Button>
                    <Button
                        paddingX={'16px'}
                        paddingY={'12px'}
                        color={accent}
                        // minWidth={'343px'}
                        w={{ base: 'full', lg: '5%' }}
                        margin={'auto'}
                        onClick={() => closeButtonProps?.onClick?.()}
                        cursor="pointer"
                        variant="link"
                        as={'u'}
                    >
                        {lblclose && (
                            <TextScript text={lblclose} translationKey={`Global/CloseThisPage`} />
                        )}
                    </Button>
                </Flex>
            </Box>
        </Box>
    );
};